import React from 'react';
import NewIFrameSetting from './NewIFrameSetting';

const NewIFrameSettingGroup = ({
  title,
  path,
  fields,
  handleGlobalSettingsChange,
  globalSettings,
  currentLandingSettingsOverrides,
  handleCurrentLandingSettingsOverridesChange,
}) => {
  return (
    <>
      <h3>{title}</h3>
      <div className="new-ifconstructor-setting-group">
        {fields.map((f) => {
          return (
            <NewIFrameSetting
              {...f}
              parentPath={path}
              handleGlobalSettingsChange={handleGlobalSettingsChange}
              globalSettings={globalSettings}
              currentLandingSettingsOverrides={currentLandingSettingsOverrides}
              handleCurrentLandingSettingsOverridesChange={
                handleCurrentLandingSettingsOverridesChange
              }
            />
          );
        })}
      </div>
    </>
  );
};

export { NewIFrameSettingGroup };
